import React, { useState } from "react";
import { toast } from "sonner";
import { api, brl, getUser, errMsg } from "@/lib/api";
import { useFeeRates, fmtPct } from "@/hooks/useFeeRates";

export default function Transfer() {
  const [form, setForm] = useState({ to_email: "", amount: "", note: "" });
  const [loading, setLoading] = useState(false);
  const user = getUser();
  const { rates } = useFeeRates();
  const rate = rates.transfer_fee_rate || 0;
  const total = Number(form.amount || 0);
  const fee = total * rate;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/transfer", { ...form, amount: Number(form.amount) });
      toast.success(`Transferência de ${brl(total)} enviada`);
      setForm({ to_email: "", amount: "", note: "" });
      setTimeout(() => window.location.href = "/app", 700);
    } catch (err) {
      toast.error(errMsg(err, "Erro"));
    } finally {
      setLoading(false);
    }
  };

  const inp = "w-full bg-white/[0.02] border border-white/[0.08] rounded-xl px-4 py-3 focus:border-[var(--accent)] outline-none transition-colors";

  return (
    <div className="fadeUp max-w-3xl">
      <div className="page-header">
        <div className="label-caps mb-2">Movimentação</div>
        <h1 className="page-title wrap-safe">Transferir</h1>
        <p className="page-subtitle wrap-safe">MercadoPagu → MercadoPagu. Chega na conta em segundos.</p>
      </div>

      <div className="app-card">
        <div className="flex items-baseline justify-between mb-6 flex-wrap gap-2">
          <div>
            <div className="label-caps">Seu saldo</div>
            <div className="font-display font-black text-fluid-h2 text-[var(--accent)] tabular-nums leading-none">{brl(user?.balance || 0)}</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-caps block mb-2">E-mail do destinatário</label>
            <input type="email" required value={form.to_email} onChange={(e) => setForm({ ...form, to_email: e.target.value })} data-testid="transfer-to" className={inp} placeholder="destino@email.com" />
          </div>
          <div>
            <label className="label-caps block mb-2">Valor</label>
            <div className="flex items-center gap-3 border border-white/[0.08] bg-white/[0.02] rounded-xl px-4 py-3 focus-within:border-[var(--accent)] transition-colors">
              <span className="text-white/60 font-mono">R$</span>
              <input
                type="number" step="0.01" min="0.01" required
                value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })}
                data-testid="transfer-amount"
                className="flex-1 bg-transparent outline-none font-display text-2xl font-bold min-w-0"
                placeholder="0,00"
              />
            </div>
          </div>
          <div>
            <label className="label-caps block mb-2">Observação (opcional)</label>
            <input value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="transfer-note" className={inp} placeholder="Ex: Pagamento serviços" />
          </div>
          <div className="border-t border-white/[0.06] pt-4 space-y-1.5 text-sm" data-testid="transfer-fee-preview">
            <div className="flex justify-between"><span className="text-white/60">Valor enviado</span><span className="tabular-nums">{brl(total)}</span></div>
            <div className="flex justify-between"><span className="text-white/60">Taxa plataforma ({fmtPct(rate)})</span><span className="text-[var(--accent)] tabular-nums">{brl(fee)}</span></div>
            <div className="flex justify-between font-bold pt-2 border-t border-white/[0.06]"><span>Total a debitar</span><span className="text-[var(--danger)] tabular-nums">{brl(total + fee)}</span></div>
          </div>
          <button disabled={loading} data-testid="transfer-submit" className="btn-primary w-full">
            {loading ? "Enviando..." : "Confirmar transferência"}
          </button>
        </form>
      </div>
    </div>
  );
}
